import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Paper from "components/Paper";
import Text from "components/Text";
import Button from "components/Button";
import Input from "components/FormComponents/ControlledInput";
import clsx from "clsx";
import * as yup from "yup";
import { reportError } from "crashlytics";

import styles from "./index.module.css";

import { writeToStorage, readFromStorage } from "../../utils/storage";
import { QueryKeys, RomanianMonths } from "common/constants";
import { useReserveUpdate } from "queries/service";

const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
};

const Document = () => {
    const history = useHistory();
    const [checkboxValue, setCheckboxValue] = useState(false);

    //----------start data---------------//


    let query = useQuery();
    const serviceId = readFromStorage(QueryKeys.serviceId)

    const additionalData = readFromStorage(QueryKeys.additionalData);
    
    const defaultValues = {
        additional: additionalData || null,
    }

    const schema = yup.object({
        additional: yup.string(),
    }).required();

    const formMethods = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(schema)
    });

    const { control, handleSubmit, watch, setValue, errors, formState } = formMethods;


    const onSubmit = async (data) => {
        if (!data) return;
        writeToStorage(QueryKeys.additionalData, data?.additional);

        try {
            history.push(`/programare/step6?service_id=${serviceId}`)
        } catch (error) {
            reportError("Document: onSubmit: error:", error);
        }
    };
    //----------end data---------------//


    return (
        <div className={styles.documentPage}>
            <div className={styles.pageHeader}>
                <Text type={"h3"}>Pasul 3 din 5</Text>
                <Text type={"h1"}>
                    Nr. de înregistrare al documentelor de ridicat
                </Text>
            </div>

            <Paper className={styles.paper}>
                <FormProvider {...formMethods}>
                    <form
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <Input
                            className="mb-12"
                            name="additional"
                            label="Detalii despre documente  *"
                            lines={7}
                            maxLength={250}
                        />

                        <Text type={"h3"}>
                            Vă rugăm să ne furnizați detalii complete despre
                            documentul/documentele pe care doriți să le
                            ridicați (Nume, Prenume, Număr de înregistrare), astfel încât să le avem pregătite pentru
                            întâlnire.
                            <br />
                            <br />
                            (Maxim 250 de caractere)
                        </Text>
                        <div
                            className={clsx(
                                styles.actionContainer,
                                styles.alignCenter,
                                styles.spaceBtw
                            )}
                        >
                            <Button
                                className={styles.prevButton}
                                size="large"
                                variant="secondary"
                                label="<- înapoi"
                                onClick={history.goBack}
                            />
                            <Button
                                className={styles.nextButton}
                                size="large"
                                label="Continuă ->"
                                type="submit"
                                disabled={!formState.isValid}
                            />
                        </div>
                    </form>
                </FormProvider>

            </Paper>
        </div>
    );
};

export default Document;
